export default {
  URL: window.PP && window.PP.AppURL,
  LANG: window.PP && window.PP.AppLang,
  DEBUG: window.PP && window.PP.AppDebug,

  EVENTS: {
    RESIZE: 'resize',
    RESIZE_DEBOUNCED: 'resizeDebounced',
    OPEN_SIDE_NAVI: 'openSideNavi',
    UPDATE_CART_QUANTITY: 'updateCartQuantity',
    SHOW_LOGIN: 'showLogin',
  },

  MOBILE_WIDTH: 700,
  PRE_TABLET_WIDTH: 900,
  TABLET_WIDTH: 1200,
  DESKTOP_WIDTH: 1480,
  LARGE_WIDTH: 1800,
}
